<div class="container-fluid ">
    <div class="row justify-content-center">
        <mat-form-field class="col col-md-6">
            <input matInput placeholder="Sélectionner un utilisateur" [(ngModel)]="SearchedString"
                   type="text" aria-label="Number" (keyup)="onKeyUp()">
            <!--             <mat-autocomplete #auto="matAutocomplete" (optionSelected)="assignSelectedUser($event)"
                [displayWith]="displayFn" [compareWith]="compareWith">
                <mat-option *ngFor="let u of UserList" [value]="u">
                    {{u.FirstName}} {{u.LastName}} - {{u.Email}}
                </mat-option>
            </mat-autocomplete>
 -->
        </mat-form-field>
        <button appPreventDoubleClick class="col-auto ms-1" style="height: fit-content;" color="accent"
                mat-raised-button (throttledClick)="openCreationBox()">
            Nouvel utilisateur
            <mat-icon class="material-symbols-outlined">add</mat-icon>
        </button>
    </div>
    <div class="row">
        <div class="col-12 col-md-3">
            <div *ngFor="let u of UserList" class="mt-2 border rounded-1" (click)="SelectedUser=u"
                 [ngStyle]="{'background-color': SelectedUser==u ? 'lightblue': 'white' }">
                <app-avatar [FirstName]="u.FirstName" [LastName]="u.LastName" [IsBold]="u.Type==1"></app-avatar>
            </div>
        </div>
        <div class="col-12 col-md-9">
            <div *ngIf="SelectedUser" class="row justify-content-center m-1">
                <div *ngIf="SelectedUser" class="card my-3 p-0">

                    <h5 class="card-header"> Informations utilisateur</h5>

                    <div class="card-body">
                        <div class="row">
                            <p class="col-6 card-text text-end fst-italic">Email</p>
                            <span class="col row">
                                <p class="col card-text text-start">{{SelectedUser.Email}}</p>
                            </span>
                        </div>
                        <div class="row">
                            <p class="col card-text text-end fst-italic">Prénom</p>
                            <p class="col card-text text-start">{{SelectedUser.FirstName}}</p>
                        </div>
                        <div class="row">
                            <p class="col card-text text-end fst-italic">Nom</p>
                            <p class="col card-text text-start">{{SelectedUser.LastName}}</p>
                        </div>

                      

                        <div class="row d-flex justify-content-end no-gutters">
                            <button appPreventDoubleClick mat-mini-fab class="mx-2" color="accent" matTooltip="Ré-envoyer un mail d'activation"
                                    (throttledClick)="resetPasswordForASpecificContact(SelectedUser.Email)">
                                <mat-icon class="material-symbols-outlined">replay</mat-icon>
                            </button>
                            <button appPreventDoubleClick mat-mini-fab class="mx-2" [matTooltip]="SelectedUser.IsActive ? 'Actif' : 'Inactif'" [color]="SelectedUser.IsActive ? 'accent' : ''" (throttledClick)="activeUnactiveUser(SelectedUser.Email)">
                                    <mat-icon class="material-symbols-outlined">verified
                                </mat-icon>
                            </button>
                            <button appPreventDoubleClick mat-mini-fab class="mx-2" color="accent"
                                    (throttledClick)="openCreationBox(SelectedUser)">
                                <mat-icon class="material-symbols-outlined">edit</mat-icon>
                            </button>

                            <button appPreventDoubleClick mat-mini-fab class="mx-2" color="warn" (throttledClick)="deleteUser()">
                                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <div *ngIf="SelectedUser" class="row justify-content-center m-1">
                
                <div class="card w-50 my-3 p-0">
                    <h5 class="card-header">Liste des contacts associés</h5>
                    <div class="row justify-content-center p-2 mt-2">
                        <mat-list>
                            <ng-container *ngFor="let c of SelectedUser?.ContactList">
                                <mat-list-item>
                                    <mat-icon class="me-3 material-symbols-outlined">face</mat-icon>
                                    {{c.Code}}
                                    <mat-icon class="clickable hidden-element mx-2 material-symbols-outlined"
                                              (click)="deleteContact(c)">delete_outline</mat-icon>
                                </mat-list-item>
                            </ng-container>
                        </mat-list>
                        <div class="col-auto">
                            <button appPreventDoubleClick mat-raised-button color="primary"
                                    (throttledClick)="openContactSelectionBox()" [disabled]="">
                                Nouveau Contact
                                <mat-icon class="material-symbols-outlined">add</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>